export default {
    name: 'QComment',
    props: {
        user: {
            type: Object,
            default: null
        },
        timestamp: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        showDate: {
            type: Boolean,
            default: false
        },
        isSent: {
            type: Boolean,
            default: false
        },
        isPropertyEmployee: {
            type: Boolean,
            default: false
        },
        isSystemMessage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userId: this.user.id
        };
    },
    computed: {
        formattedTime() {
            if (this.timestamp) {
                return this.$moment
                    .utc(this.timestamp)
                    .local()
                    .format('h:mma');
            }

            return '';
        },
        isLoggedInUser() {
            const loggedInUser = JSON.parse(window.localStorage.getItem('authenticated'));

            if (loggedInUser && loggedInUser.user && loggedInUser.user.id) {
                return loggedInUser.user.id === parseInt(this.user.id);
            }

            return false;
        },
        showAvatar() {
            return this.isSystemMessage || !this.isLoggedInUser;
        }
    }
};
